import { components } from "@/api-schema";
import { GroupMembershipSource } from "@/api-schema-enums";
import { ImplementedAccessorColumnDef } from "@/components/data-table/types";
import { Badge, BadgeColorVariant, BadgeVariant } from "@/components/ui/badge";
import i18next from "i18next";

export type UserGroupRow = components["schemas"]["UserGroupResponseDto"];

const SOURCE_BADGES: Record<GroupMembershipSource, { labelKey: string; colorVariant: BadgeColorVariant }> = {
  [GroupMembershipSource.Rule]: { labelKey: "ram:RuleBased", colorVariant: BadgeColorVariant.Primary },
  [GroupMembershipSource.Manual]: { labelKey: "common:Manually", colorVariant: BadgeColorVariant.Success },
  [GroupMembershipSource.Temporary]: { labelKey: "ram:Temporary", colorVariant: BadgeColorVariant.Warning },
};

export const userGroupTableDefaultColumns = {
  columnName: {
    id: "name",
    size: 600,
    enableSorting: true,
    header: () => i18next.t("ram:Group"),
    accessorFn: (row: UserGroupRow) => row.name,
    cell: (row) => <span className="font-medium">{row.getValue() as string}</span>,
  } as ImplementedAccessorColumnDef<UserGroupRow, string>,

  columnSources: {
    id: "sources",
    size: 300,
    enableSorting: false,
    header: () => i18next.t("ram:MembershipSource"),
    accessorFn: (row: UserGroupRow) => row.sources,
    cell: (row) => (
      <div className="flex flex-wrap gap-1">
        {(row.getValue() as GroupMembershipSource[]).map((source) => (
          <Badge key={source} variant={BadgeVariant.Outlined} colorVariant={SOURCE_BADGES[source].colorVariant}>
            {i18next.t(SOURCE_BADGES[source].labelKey)}
          </Badge>
        ))}
      </div>
    ),
  } as ImplementedAccessorColumnDef<UserGroupRow, GroupMembershipSource[]>,
};
